// extracted by mini-css-extract-plugin
export var active = "_4p-7";
export var container = "_4p-0";
export var evenWidth = "_4p-4";
export var large = "_4p-5";
export var outlet = "_4p-8";
export var slide = "_4p-2";
export var small = "_4p-6";
export var tab = "_4p-3";
export var tabs = "_4p-1";